import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { useIntercom } from 'react-use-intercom'
import { ServiceTicketIcon } from './images'
import {
  ContentBlock,
  HelpItemWrapper,
  ItemIcon,
  SubTitle,
  Title
} from './styledComponents'
import colorsOptions from '../../components/stories/fundamentals/colors-styles/constants'
import { StyledLink } from '../../components/form-fields/styled-components'

export const IntercomLink = ({ dataTestId }) => {
  const { boot, show } = useIntercom()

  const onLinkClick = () => {
    boot()
    setTimeout(show, 200)
  }

  return (
    <StyledLink {...dataTestId} onClick={onLinkClick}>
      <FormattedMessage id="registerForm_contactSupport" />
    </StyledLink>
  )
}

IntercomLink.propTypes = {
  dataTestId: PropTypes.string
}

const IntercomHelpItemWrapper = ({ toggle }) => {
  const { show } = useIntercom()

  const onClickIntercom = () => {
    toggle()
    show()
  }

  return (
    <HelpItemWrapper onClick={onClickIntercom}>
      <ItemIcon>
        <ServiceTicketIcon
          size={32}
          hoverColor={colorsOptions.docuToolsOrange.orange}
        />
      </ItemIcon>
      <ContentBlock>
        <Title>
          <FormattedMessage id="help_view_service_ticket_title" />
        </Title>
        <SubTitle>
          <FormattedMessage id="help_view_service_ticket_message" />
        </SubTitle>
      </ContentBlock>
    </HelpItemWrapper>
  )
}

IntercomHelpItemWrapper.propTypes = {
  toggle: PropTypes.func
}

export default IntercomHelpItemWrapper
